import { languageConstants as LC } from '../constants/'

import {
  ASC,
  getSession,
  getStorage,
  removeStorage,
  setSession,
  setStorage,
  initialChartConfig,
} from './'

const initStorage = (key, defaultValue, useSession = false) => {
  const getter = useSession ? getSession : getStorage
  const setter = useSession ? setSession : setStorage

  if (!getter(key)) setter(key, defaultValue)
}

export const createStorageConfig = () => {
  // global
  const defaultSettings = {
    alertsEnabled: true,
    alertsAcknowledged: [],
    alertsMax: 3,
    mask: 7,
    salutationMode: 'default',
    timeMode: 'relative',
    showSettings: false,
    setupTab: 0,
    isMaintenance: 0,
    maintenanceMessage: '',
  }
  const currentSettings = getStorage('settings_global') || {}
  setStorage('settings_global', {
    ...defaultSettings,
    ...currentSettings,
  })

  // dashboard
  initStorage('settings_dashboard', { objectFilter: '' })
  initStorage('settings_dashboards', { selectedId: 0 })
  initStorage('settings_dashboard_id', { maxColItems: 2, panelHeight: 250 })

  // reports
  initStorage('settings_reports_all', { tab: 'mbr' })
  initStorage('settings_report_generator', { tab: 0 })

  // notifications
  initStorage('settings_notifications_all', {
    filter: '',
    order: ASC,
    orderby: 'name',
    poolInfo: false,
  })

  // folders
  initStorage('settings_folders_all', {
    filter: '',
    itemView: 'list',
    map: false,
    order: ASC,
    orderby: 'name',
    poolInfo: false,
    type: LC.FOLDERTYPE_ANY,
  })

  // sensors
  initStorage('settings_sensors_all', {
    actionMenu: null,
    exportDialog: false,
    exportMode: 'page',
    maxResults: '10',
    order: ASC,
    orderby: 'name',
  })
  initStorage('settings_sensor_edit', { tab: 0 })

  // virtual sensors
  initStorage('settings_virtual_sensors_all', { maxResults: 20 })

  // news
  initStorage('settings_news_all', {
    filter: '',
    order: ASC,
    orderby: 'title',
    poolInfo: false,
    type: LC.NEWSTYPE_ANY,
    category: [LC.NEWSCATEGORY_CONTRACT, LC.NEWSCATEGORY_OBJECT],
  })

  // users
  initStorage('settings_users_all', {
    filter: '',
    order: ASC,
    orderby: 'firstname',
    poolInfo: false,
    role: [
      LC.USERROLE_GUEST,
      LC.USERROLE_USER,
      LC.USERROLE_COACH,
      LC.USERROLE_ADMIN,
    ],
    status: [LC.USERSTATUS_ACTIVE, LC.USERSTATUS_INACTIVE],
  })
  initStorage('settings_user_edit', {
    assignedContractsOnly: false,
    assignedFoldersOnly: false,
    assignedSensorsOnly: false,
    assignmentSection: 0,
    confirmDelete: false,
    editAvatar: false,
    maxResults: 10,
    order: 'desc',
    orderBy: 'entity_id',
    tab: 0,
  })

  // consumption + detail
  initStorage('settings_performance', {
    chartType: 'ColumnChart',
    view: 'daily',
  })
  initStorage('settings_feeling_history', {
    limitsDialog: false,
    exportDialog: false,
    chartType: 'AreaChart',
    lineColor: '#A00',
  })

  // security
  initStorage('settings_security_history', {
    limitsDialog: false,
    exportDialog: false,
    chartType: 'AreaChart',
    lineColor: '#A00',
  })

  // session-based configs
  initStorage('settings_performance_detail', initialChartConfig, true)
  initStorage('settings_correlation', initialChartConfig, true)
  initStorage('settings_installation_detail', initialChartConfig, true)
}

export const deleteStorageConfig = () => {
  removeStorage('settings_global')
  removeStorage('settings_dashboard')
  removeStorage('settings_dashboards')
  removeStorage('settings_dashboard_id')
  removeStorage('settings_reports_all')
  removeStorage('settings_report_generator')
  removeStorage('settings_notifications_all')
  removeStorage('settings_folders_all')
  removeStorage('settings_sensors_all')
  removeStorage('settings_sensor_edit')
  removeStorage('settings_virtual_sensors_all')
  removeStorage('settings_news_all')
  removeStorage('settings_users_all')
  removeStorage('settings_user_edit')
  removeStorage('settings_performance')
  removeStorage('settings_performance_detail')
  removeStorage('settings_feeling_history')
  removeStorage('settings_security_history')
  removeStorage('settings_correlation')
  removeStorage('settings_installation_detail')
}
